import { RESET_CTR_SECTION_ERROR } from '.';

export default payload => ({
  type: RESET_CTR_SECTION_ERROR,
  payload,
});
